<template>
    <div class="flex-grow">
        <div class="p-lg border-b border-neutral-lightest">
            <div class="flex justify-start">
                <div>
                    <checkbox-input
                        v-model="allAddressesSelected"
                        class="mr-md pt-px pb-px"
                        @toggle="toggleAddressesSelection"
                    >
                        <span class="headline-sm font-semibold">
                            Adresser ({{ selectedAddresses.length }}/{{ addressesCount }})
                        </span>
                    </checkbox-input>
                </div>
            </div>
        </div>
        <ul class="list-reset text-sm h-full pb-4xl">
            <div class="pb-4xl mb-md">
                <address-list
                    v-for="(addresses, streetName) in streets"
                    :key="'street_list_item' + streetName"
                    :addresses="addresses"
                    :selected-addresses="selectedAddresses"
                    :assigned-addresses="assignedAddresses"
                    :street-name="streetName"
                    :is-last-street="isLastStreet(streetName)"
                />
            </div>
        </ul>
    </div>
</template>

<script>
    import AddressList from './AddressList';

    export default {
        components: { AddressList },
        props: {
            streets: {
                required: true,
                type: Object,
            },
            selectedAddresses: {
                required: true,
                type: Array,
            },
            assignedAddresses: {
                required: true,
                type: Array,
            },
            addressesCount: {
                required: true,
                type: Number,
            },
        },

        data() {
            return {
                allAddressesSelected: false,
            };
        },

        methods: {
            isLastStreet(streetName) {
                const keys = Object.keys(this.streets);

                return keys[keys.length - 1] === streetName;
            },
            toggleAddressesSelection() {
                EventBus.$emit('toggle-addresses-selection', this.allAddressesSelected);
            },
        },
    };
</script>
